import React, { useState } from "react";
import { Container, Row, Col, Form, Button, Card, InputGroup } from "react-bootstrap";
import { handleResetPassword } from "../../store/actions/userActions";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { FaSearch, FaEye, FaEyeSlash, FaUserPlus } from "react-icons/fa";
import logo from "../../assets/icons/logo.svg";
import { IMAGES } from "../../constants/constants";
import "../../styles/Dashboard.css";
import "./login.css";

function UpdatePassword() {
  const { email } = useParams(); // Get email from URL params
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [formData, setFormData] = useState({
    email: email || "", // Prefill email from URL params
    newPassword: "",
    confirmPassword: "",
  });

   const [showPassword, setShowPassword] = useState(false); // Add this line at the top with other state variables
  
  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev); // Toggle the password visibility
  };
  const [error, setError] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (formData.newPassword !== formData.confirmPassword) {
      setError("Passwords do not match!");
      return;
    }

    const result = await handleResetPassword(
      { email: formData.email, password: formData.newPassword },
      dispatch
    );

    if (result.message === "Success") {
        navigate("/");
    } else {
      setError(result.message || "Password reset failed!");
    }
  };

  return (
    <Container
      fluid
      className="d-flex align-items-center justify-content-center"
      style={{ minHeight: "100vh", backgroundColor: "#f8f9fa" }}
    >
      <Card className="auth-card">
        <Row className="g-0">
          {/* Left Section - Reset Password Form */}
          <Col md={6}>
            <Card.Body className="d-flex flex-column auth-form-body">
              <div className="mb-4 auth-form-logo">
                <img src={logo} alt="logo" />
              </div>
              <p>Reset Password</p>
              <p>Enter a new password for your account.</p>
              {error && <p className="text-danger">{error}</p>}
              <Form onSubmit={handleSubmit}>
                <Form.Group className="mb-3" controlId="formNewPassword">
                  <Form.Label className="auth-form-label">
                    New Password<span>*</span>
                  </Form.Label>
                  <InputGroup>
                  <Form.Control
                   // className="auth-form-input"
                    // type="password"
                    type={showPassword ? "text" : "password"}
                    placeholder="Enter new password"
                    name="newPassword"
                    value={formData.newPassword}
                    onChange={handleChange}
                  />
                  <InputGroup.Text
                          onClick={togglePasswordVisibility}
                          style={{
                            cursor: "pointer",
                            borderLeft: "none",
                            background: "transparent",
                            
                          }}
                        >
                          {showPassword ? <FaEye /> : <FaEyeSlash />}{" "}
                          {/* Eye icon for visibility toggle */}
                        </InputGroup.Text>
                        </InputGroup>
                </Form.Group>

                <Form.Group className="mb-3" controlId="formConfirmPassword">
                  <Form.Label className="auth-form-label">
                    Confirm Password<span>*</span>
                  </Form.Label>
                  <InputGroup>
                  <Form.Control
                   // className="auth-form-input"
                    // type="password"
                    type={showPassword ? "text" : "password"}
                    placeholder="Confirm new password"
                    name="confirmPassword"
                    value={formData.confirmPassword}
                    onChange={handleChange}
                  />
                   <InputGroup.Text
                          onClick={togglePasswordVisibility}
                          style={{
                            cursor: "pointer",
                            borderLeft: "none",
                            background: "transparent",
                          }}
                        >
                          {showPassword ? <FaEye /> : <FaEyeSlash />}{" "}
                          {/* Eye icon for visibility toggle */}
                        </InputGroup.Text>
                        </InputGroup>
                </Form.Group>

                <Button
                  type="submit"
                  className="w-100 auth-form-btn"
                  style={{ backgroundColor: "#56934e", border: "#56934e" }}
                >
                  Update Password
                </Button>
              </Form>
            </Card.Body>
          </Col>

          {/* Right Section - Static Image */}
          <Col md={6} className="d-flex justify-content-center align-items-center">
            <div
              className="h-100 w-100"
              style={{
                backgroundImage: `url(${IMAGES.loginFormImage})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                borderRadius: "0 15px 15px 0",
              }}
            ></div>
          </Col>
        </Row>
      </Card>
    </Container>
  );
}

export default UpdatePassword;
